import { NavLink } from "react-router-dom";
import {
  ArrowCircleDown, ArrowCircleUp, ArrowRight, CalendarDots, ChartPieSlice,
  CheckCircle, Factory, Gear, Invoice, Receipt, Warning, ArrowsDownUp, Bank,
} from "@phosphor-icons/react";
import Layout from "@/components/Layout";
import { PageHeader } from "@/components/Bits";

const groups = [
  { title: "Operasyon", items: [
    { to: "/etkinlikler", label: "Etkinlikler", text: "İş maliyetleri ve satışları", icon: CalendarDots },
    { to: "/uretimler", label: "Üretimler", text: "Üretim kayıtları ve maliyetler", icon: Factory },
    { to: "/raporlar", label: "Raporlar", text: "Teslim ve bekleyen raporlar", icon: CheckCircle },
  ] },
  { title: "Finans", items: [
    { to: "/satis-faturalari", label: "Satış Faturaları", text: "Kesilen ve bekleyen faturalar", icon: Invoice },
    { to: "/alis-faturalari", label: "Alış Faturaları", text: "Gelen faturalar", icon: Receipt },
    { to: "/gelen-odemeler", label: "Gelen Ödemeler", text: "Tahsilat takibi", icon: ArrowCircleDown },
    { to: "/giden-odemeler", label: "Giden Ödemeler", text: "Ödeme planı", icon: ArrowCircleUp },
    { to: "/nakit-akisi", label: "Nakit Akışı", text: "Haftalık ve aylık projeksiyon", icon: ArrowsDownUp },
    { to: "/bankacilik", label: "Bankacılık", text: "Hesaplar, kartlar ve krediler", icon: Bank },
    { to: "/gerceklesen", label: "Gerçekleşen", text: "Aylık mali sonuçlar", icon: ChartPieSlice },
  ] },
  { title: "Sistem", items: [
    { to: "/uyarilar", label: "Uyarılar", text: "Veri kontrol bildirimleri", icon: Warning },
    { to: "/ayarlar", label: "Ayarlar", text: "Google Drive ve uygulama tercihleri", icon: Gear },
  ] },
];

export default function Main() {
  return <Layout><PageHeader title="Flum World" subtitle="HIZLI ERİŞİM" />
    <div className="space-y-7">{groups.map((group) => <section key={group.title}><h2 className="section-title">{group.title}</h2><div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">{group.items.map((item) => <NavLink key={item.to} to={item.to} className="card-flat group flex min-h-32 items-center gap-4 p-5 transition-colors hover:bg-neutral-50"><span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm bg-neutral-100 text-neutral-900 group-hover:bg-neutral-900 group-hover:text-white"><item.icon size={23} weight="duotone" /></span><span className="min-w-0 flex-1"><span className="block font-bold">{item.label}</span><span className="mt-1 block text-sm text-neutral-500">{item.text}</span></span><ArrowRight size={18} className="shrink-0 text-neutral-400 transition-transform group-hover:translate-x-1 group-hover:text-neutral-900" /></NavLink>)}</div></section>)}</div>
  </Layout>;
}
